import { getContext } from 'configs/context';

import { PUBLISH_EVENT } from 'configs/constants';

// @deprecated SDK API: there is no setPremiumContent handler in @picsart/miniapps-sdk
// v15.6.0 (scene.pricing.isPremium is a read-only model). This stays on the deprecated
// publishEvent to push premium state to the platform until a setter is exposed.
const sendPremiumContentInfo = (isPremiumContent: boolean) =>
  getContext().handlers.publishEvent({
    event: PUBLISH_EVENT.PREMIUM_CONTENT_INFO,
    data: { isPremiumContent },
  });

export default sendPremiumContentInfo;
